module.exports = __webpack_public_path__ + "static/img/9.c08d940.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/2/eng/9.png
// module id = zbHg
// module chunks = 0